// Entrada monetária digitada em pt-BR ("1.234,56", "1234,5", "R$ 10") -> string canônica
// "1234.56" enviada à API. Sem aritmética de ponto flutuante.
export function parseMoneyInput(input) {
  if (input === null || input === undefined) return null;
  let s = String(input)
    .trim()
    .replace(/^R\$\s*/i, '')
    .replace(/\s/g, '');
  if (!s) return null;
  if (s.includes(',')) s = s.replace(/\./g, '').replace(',', '.');
  else if (/^\d{1,3}(\.\d{3})+$/.test(s)) s = s.replace(/\./g, ''); // "1.234" = mil duzentos...
  const m = /^(\d{1,12})(?:\.(\d{1,2}))?$/.exec(s);
  if (!m) return null;
  const int = m[1].replace(/^0+(?=\d)/, '');
  const frac = (m[2] ?? '').padEnd(2, '0');
  return `${int}.${frac}`;
}

/** "1234.50" -> "1.234,50" para preencher campos de edição. */
export function moneyToInput(amount) {
  if (!amount) return '';
  const [int, frac = '00'] = String(amount).split('.');
  return `${int.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${frac.padEnd(2, '0').slice(0, 2)}`;
}

/** Soma de valores canônicos em centavos inteiros (para totais exibidos no front). */
export function sumAmounts(amounts) {
  let cents = 0n;
  for (const a of amounts) {
    if (!a) continue;
    const [i, f = '0'] = String(a).replace('-', '').split('.');
    const v = BigInt(i) * 100n + BigInt(f.padEnd(2, '0').slice(0, 2));
    cents += String(a).startsWith('-') ? -v : v;
  }
  const neg = cents < 0n;
  const abs = neg ? -cents : cents;
  return `${neg ? '-' : ''}${abs / 100n}.${String(abs % 100n).padStart(2, '0')}`;
}
